(function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var banners = document.querySelectorAll('.parallax-banner');
    if (!banners.length) return;

    var ticking = false;

    function updateLayers() {
    banners.forEach(function (banner) {
    var rect = banner.getBoundingClientRect();
    var viewportH = window.innerHeight || document.documentElement.clientHeight;
    if (rect.bottom < 0 || rect.top > viewportH) return;
    var progress = (viewportH - rect.top) / (viewportH + rect.height);
    var offset = (progress - 0.5) * 60;
    var layers = banner.querySelectorAll('.parallax-banner__layer');
    layers.forEach(function (layer) {
    layer.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
    });
    });
    ticking = false;
    }

    function onScroll() {
    if (!ticking) {
    window.requestAnimationFrame(updateLayers);
    ticking = true;
    }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateLayers();
    })();